import { useQuery } from "@tanstack/react-query";
import { lazy, useEffect, useMemo, useRef } from "react";
import { getPWAReward } from "~/app/components/layout/ModalPWAReward/api/getPWAReward";
import { useIsAuthenticated } from "~/stores/auth";
import { usePWARewardStore } from "~/stores/pwareward";

export const usePWAReward = () => {
  const isAuthenticated = useIsAuthenticated();
  const isClaimedFlag = useRef(false);
  const { data } = useQuery({
    queryKey: ["apiPWARewardGet"],
    queryFn: getPWAReward,
    retry: 2,
    retryDelay: 300,
    enabled: isAuthenticated && !isClaimedFlag.current,
  });

  const { setIsOpenModalPWAReward } = usePWARewardStore();

  const ModalPWAReward = useMemo(
    () =>
      lazy(() =>
        import("~/app/components/layout/ModalPWAReward/ModalPWAReward").then((res) => ({
          default: res.ModalPWAReward,
        })),
      ),
    [],
  );

  useEffect(() => {
    if (data) {
      setIsOpenModalPWAReward(data.isPWARewardClaimed === false);
      isClaimedFlag.current = data.isPWARewardClaimed;
    }
  }, [data, setIsOpenModalPWAReward]);

  return {
    isPWARewardClaimed: data?.isPWARewardClaimed,
    pwaRewardAmount: data?.storeListing?.DisplayDetails.Title || "0",
    ModalPWAReward,
  };
};
